module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_5010.7365e779.png";